import {format, formatISO, getDate, getYear} from 'date-fns'
import itLocale from 'date-fns/locale/it';

const INVALID_DATE_STR = "INVALID DATE";

/*
 Example: lun 16 maggio 2022, 23:59
 */
const dateAndTime = (date) => {
    let formattedDate;
    try {
        formattedDate = format(date, 'ccc PPP, HH:mm', {locale: itLocale});
    } catch (e) {
        console.error(`Unable to format the given  date: ${date}. Got:`, e);
        formattedDate = INVALID_DATE_STR;
    }
    return formattedDate;
}

/*
 Example: Friday, April 29th, 1453
 */
const longStringWithDayName = (date) => {
    let formattedDate;
    try {
        formattedDate = format(date, 'ccc PPP', {locale: itLocale});
    } catch (e) {
        console.error(`Unable to format the given  date: ${date}. Got:`, e);
        formattedDate = INVALID_DATE_STR;
    }
    return formattedDate;
}

/*
 Example: 16 maggio 2022
 */
const longString = (date) => {
    let formattedDate;
    try {
        formattedDate = format(date, 'PPP', {locale: itLocale});
    } catch (e) {
        console.error(`Unable to format the given  date: ${date}. Got:`, e);
        formattedDate = INVALID_DATE_STR;
    }
    return formattedDate;
};

/*
 Example: 16 mag 2022
 */
const shortString = (date) => {
    let formattedDate;
    try {
        formattedDate = format(date, 'PP', {locale: itLocale});
    } catch (e) {
        console.error(`Unable to format the given  date: ${date}. Got:`, e);
        formattedDate = INVALID_DATE_STR;
    }
    return formattedDate;
};

/*
 Example: sab 18 set 2023
 */
const shortStringWithDayName = (date) => {
    let formattedDate;
    try {
        formattedDate = format(date, 'ccc PP', {locale: itLocale});
    } catch (e) {
        console.error(`Unable to format the given  date: ${date}. Got:`, e);
        formattedDate = INVALID_DATE_STR;
    }
    return formattedDate;
};

const dmyString = (date) => {
    let formattedDate;
    try {
        formattedDate = format(date, 'dd/MM/yy', {locale: itLocale});
    } catch (e) {
        console.error(`Unable to format the given  date: ${date}. Got:`, e);
        formattedDate = INVALID_DATE_STR;
    }
    return formattedDate;
};

const monthNameShortString = (date) => {
    let formattedDate;
    try {
        formattedDate = format(date, 'MMM', {locale: itLocale});
    } catch (e) {
        console.error(`Unable to format the given  date: ${date}. Got:`, e);
        formattedDate = 'UNK';
    }
    return formattedDate;
}

const onlyDateString = (date) => getDate(date).toString();

const onlyYearString = (date) => getYear(date).toString();

const onlyDayNameString = (date, fmt='ccc') => format(date, fmt, {locale: itLocale});

const timeString = (date) => {
    let formattedDate;
    try {
        formattedDate = format(date, 'HH:mm', {locale: itLocale});
    } catch (e) {
        console.error(`Unable to format the given  date: ${date}. Got:`, e);
        formattedDate = 'UNK';
    }
    return formattedDate;
}

const onlyDateISOString = (date, invalidDate) => {
    let formattedDate;
    try {
        formattedDate = formatISO(date, {representation: 'date'});
    } catch (e) {
        console.error(`Unable to format the given  date: ${date}. Got:`, e);
        formattedDate = invalidDate || INVALID_DATE_STR;
    }
    return formattedDate;
};

export const ISOString = (date, invalidDate) => {
    let formattedDate;
    try {
        formattedDate = formatISO(date);
    } catch (e) {
        console.error(`Unable to format the given  date: ${date}. Got:`, e);
        formattedDate = invalidDate || INVALID_DATE_STR;
    }
    return formattedDate;
}

export {dateAndTime, longStringWithDayName, longString, shortStringWithDayName, shortString, dmyString, monthNameShortString, onlyDateString, onlyYearString, onlyDateISOString, onlyDayNameString, timeString}